(() => {
  const cartPageUrl = () => `${(window.Shopify?.routes?.root || '/').replace(/\/$/, '')}/cart`;
  let redirectPending = false;
  let resetTimer = 0;

  const redirectAfterCartUpdate = () => {
    if (redirectPending) return;
    redirectPending = true;

    const handleCartUpdate = () => {
      window.clearTimeout(resetTimer);
      window.location.assign(cartPageUrl());
    };

    document.addEventListener('cart:updated', handleCartUpdate, { once: true });
    resetTimer = window.setTimeout(() => {
      document.removeEventListener('cart:updated', handleCartUpdate);
      redirectPending = false;
    }, 15000);
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const buyNow = event.target.closest('[data-rp-bundle-buy], [data-rp-recommendation-buy]');
    if (!buyNow) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (buyNow.disabled || redirectPending) return;

    const addButton = buyNow.matches('[data-rp-bundle-buy]')
      ? buyNow.closest('[data-rp-bundle]')?.querySelector('[data-rp-bundle-submit]')
      : buyNow.closest('.rp-recommendations__actions')?.querySelector('[data-rp-recommendation-add]');

    if (!addButton || addButton.disabled) return;

    redirectAfterCartUpdate();
    addButton.click();
  }, true);
})();
